import { render, staticRenderFns } from "./LinkToRequestModal.vue?vue&type=template&id=9978e1e4&"
import script from "./LinkToRequestModal.vue?vue&type=script&lang=js&"
export * from "./LinkToRequestModal.vue?vue&type=script&lang=js&"
import style0 from "./LinkToRequestModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports